/**
 * RS Go plateform v1.0.0 - React APPLICATION
 * Copyright 2017-present, My Edition Company SAS -> for RoyalSpeed SARL
 * All rights reserved.
 *
 * @authors: José Barcelon Godfrey
 * Paris, France
 */

import React, {Component, PropTypes} from 'react'

export default class ErrorLoad extends Component {

  constructor(props){
    super(props);
    this.state = {

    }
  }
  render() {
    return  <div className="go-form-step-error">
              <div className="go-step-header align-center">
                <p className="emoji-alert"><span className="rs-icon-traffic-cone"></span></p>
                <h1>Oops. Une erreur est survenue lors de votre inscription...</h1>
                <p>Nous nous excusons pour le gene occasionné, vous pouvez cependant nous contacter directement par mail <a href="mailto:contact@royalspeed.fr">contact@royalspeed.fr</a> ou par téléphone au <a href="tel:+33145552717">01 45 55 27 17</a>.</p>
                <a href="https://royalspeed.fr" className="button go-button">Retour à royalspeed.fr</a>
              </div>
            </div>
  }

}


// WEBPACK FOOTER //
// ./go/views/components/signup/errorSend.jsx